import * as React from "react";
import { BetBtn } from "../BetBtn";
export class BetBtnAmerican extends BetBtn {
    renderContent() {
        return (React.createElement("div", { className: "rj-ev-list__bet-btn__inner", "data-uat": "div-ev-list-bet-btn-inner" },
            React.createElement("div", { className: `rj-ev-list__bet-btn__row ${!this.shouldRenderText() && !this.shouldRenderPoints() ? "rj-ev-list__bet-btn__row--empty" : ""}`, "data-uat": "div-ev-list-bet-btn-row" },
                this.renderText(),
                this.renderPoints()),
            React.createElement("div", { className: `rj-ev-list__bet-btn__row ${!this.shouldRenderOdds() ? "rj-ev-list__bet-btn__row--empty" : ""}`, "data-uat": "div-ev-list-bet-btn-row" }, this.renderOdds())));
    }
}
//# sourceMappingURL=BetBtnAmerican.js.map